import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityCustInfoVO } from '../Type/PackEntityCustInfoVO'

interface DataModel {
	cid?: string
}

/**
 *	根据cid查询用户信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.cid] 企业id
 */

export function custInfoByCid(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityCustInfoVO>
export function custInfoByCid(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityCustInfoVO extends { msg: unknown } ? PackEntityCustInfoVO['msg'] : undefined>
export function custInfoByCid(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { cid } = data
	return net('/frontApi/cust/custInfoByCid', {
		method: 'post',
		params: {
			cid,
		},

		...(options || {}),
	})
}
